export default __webpack_public_path__ + "static/media/terraform.04c66d8a.svg";